import { httpClient } from '../../httpClient'

import type { IdeaStatusResponse } from '../types'

export const getIdeaStatuses = async () => {
  const response = await httpClient.get<IdeaStatusResponse[]>(
    '/ideas/ideas/statuses',
  )
  return response.data
}
